<div class="main">
  <div class="foot">
    <div class="row-1">
      <a href="https://www.ecell.in/" target="_blank"
        ><img
          src="https://eureka2022.s3.ap-south-1.amazonaws.com/ecell-logo2.png"
          alt=""
      /></a>
      <p class="phone">
        E-Cell IIT Bombay is Asia’s Largest Entrepreneurship promoting student
        body and we build startup ecosystem on both the sides of the wall
      </p>
      <h4 class="year">27 YEARS OF CREATING JOB CREATORS</h4>
    </div>
    <div class="row-3 phone">
      <div style="width: 50%" class="quick-links">
        <h3>QUICK LINKS</h3>
        <a href="https://www.ecell.in/esummit/" target="_blank"
          ><h4>E-Summit</h4></a
        >
        <a href="https://www.ecell.in/eurekagcc" target="_blank"
          ><h4>Eureka! GCC</h4></a
        >
        <a href="https://www.ecell.in/nec/" target="_blank"><h4>NEC</h4></a>
        <a href="https://www.ecell.in/necjunior/" target="_blank"
          ><h4>NEC Junior</h4></a
        >
        <a href="https://ecell.in/junior/" target="_blank"
          ><h4>Eureka! Junior</h4></a
        >
        <a
          href="https://www.instagram.com/entrepreneurship.iitb/"
          target="_blank"
          ><h4>EnB</h4></a
        >
        <a href="https://www.ecell.in/ca" target="_blank"
          ><h4>Campus Ambassador</h4></a
        >
        <a href="https://www.ecell.in/illuminate" target="_blank"
          ><h4>Illuminate</h4></a
        >
        <!-- <a href="https://www.ecell.in/ssp/" target="_blank"><h4>SSP</h4></a> -->
      </div>
      <div style="width: 50%">
        <h3>REACH OUT</h3>
        <a href="https://goo.gl/maps/7JNM1Ax7w3QMH3jf7" target="_blank"
          ><h4 class="address">
            E-Cell Office <br />
            Student Activity<br />
            Centre (SAC)<br />
            IIT Bombay<br />
            Powai<br />
            Mumbai, India<br /></h4
        ></a>
      </div>
    </div>
  </div>
  <div class="foot-2">
    <div class="row-2">
      <h4 style="margin: 0px">Contact Us:</h4>
      <h4 style="margin-top: 0px; margin-bottom: 10px; font-size: 18px">
        <a
          href="mailto:eureka.gcc@ecell.in"
          class="maillink"
          target="_blank"
          style="color: white"
          >eureka.gcc&#64;ecell.in</a
        >
      </h4>
    </div>
    <div class="socials">
      <h4 style="margin: 0px">Follow Us:</h4>
      <div class="social">
        <div>
          <a href="https://www.facebook.com/ecell.in/" target="_blank"
            ><i class="fa-brands fa-facebook-f fa-2xl"></i
          ></a>
        </div>
        <div>
          <a href="https://www.linkedin.com/company/ecell_iitb/" target="_blank"
            ><i class="fa-brands fa-linkedin-in fa-2xl"></i
          ></a>
        </div>
        <div>
          <a href="https://www.instagram.com/iitbombay_ecell/" target="_blank"
            ><i class="fa-brands fa-instagram fa-2xl"></i
          ></a>
        </div>
        <div>
          <a href="https://twitter.com/ecell_iitb" target="_blank"
            ><i class="fa-brands fa-x-twitter fa-2xl"></i
          ></a>
        </div>
        <div>
          <a
            href="https://www.youtube.com/user/entrepreneurshipcell"
            target="_blank"
            ><i class="fa-brands fa-youtube fa-2xl"></i
          ></a>
        </div>
      </div>
      <div class="social2">
        <div>
          <a href="https://www.facebook.com/ecell.in/" target="_blank"
            ><i class="fa-brands fa-facebook-f"></i
          ></a>
        </div>
        <div>
          <a href="https://www.linkedin.com/company/ecell_iitb/" target="_blank"
            ><i class="fa-brands fa-linkedin-in"></i
          ></a>
        </div>
        <div>
          <a href="https://www.instagram.com/iitbombay_ecell/" target="_blank"
            ><i class="fa-brands fa-instagram"></i
          ></a>
        </div>
        <div>
          <a href="https://twitter.com/ecell_iitb" target="_blank"
            ><i class="fa-brands fa-x-twitter"></i
          ></a>
        </div>
        <div>
          <a
            href="https://www.youtube.com/user/entrepreneurshipcell"
            target="_blank"
            ><i class="fa-brands fa-youtube"></i
          ></a>
        </div>
      </div>
    </div>
  </div>
</div>
